import { OrderProductListItem } from '../interface/interface';

export const getNonScriptProducts = (
  products: Array<OrderProductListItem> = [],
) =>
  products.filter(
    (item) => item.orderedQty > 0 && !item.product?.requiresPrescription,
  );
